/* eslint array-callback-return: "off" */

export function checkParam(obj: Record<string, any>) {
  Object.entries(obj).map(([key, value]) => {
    if (typeof value === 'object' && value !== null) {
      checkParam(value);
    }
    if (value === undefined || value === null) {
      throw new Error(`${key} is a mandatory parameter`);
    }
  });
}
